<template>
  <b-form-group
    label="Geri Bilirim Notu"
    label-for="notes"
  >
    <validation-provider
      #default="{ errors }"
      name="Geri Bilirim Notu"
      rules="required"
    >
      <b-form-textarea
        id="notes"
        v-model="itemData.notes"
        placeholder="Geri bildirim ile ilgili notlarınız"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'NotesText',
  components: { ValidationProvider, BFormTextarea, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['feedbackNotes/dataItem']
    },
  },
}
</script>
